<template>
  <div class="m-pagination">
    <template>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :total="total"
        @current-change="handleChangePage" />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 10
    },
    page: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handleChangePage(page) {
      this.$emit('update:page', page)
      this.$emit('getItems')
    }
  }
}
</script>

<style scoped>
  .m-pagination{
    text-align: center;
    margin: 20px auto;
  }

</style>
